import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Error from "./components/WebProduct/Error.jsx"
import Navbar from "./components/Layout/Navbar.jsx"
/* USER */
import Login from "./components/Login/Login.jsx"
import LoginAdmin from "./components/Login/LoginAdmin.jsx"
import Register from "./components/Login/Register.jsx"
import LupaPassword from "./components/Login/LupaPassword.jsx"
import MenuLoading from "./components/Users/MenuLoading.jsx"
import MenuDashboard from "./components/Users/MenuDashboard.jsx"
import MenuPerusahaan from "./components/Users/MenuPerusahaan/MenuPerusahaan.jsx"
import MenuKaryawanTetap from "./components/Users/MenuKaryawan/MenuKaryawanTetap.jsx"
import MenuUbahKaryawanTetap from "./components/Users/MenuKaryawan/MenuUbahKaryawanTetap.jsx"
import MenuKaryawanTidakTetap from "./components/Users/MenuKaryawan/MenuKaryawanTidakTetap.jsx"
import MenuUbahKaryawanTidakTetap from "./components/Users/MenuKaryawan/MenuUbahKaryawanTidakTetap.jsx"
import MenuPerhitunganKaryawanTetap from "./components/Users/MenuPerhitungan/MenuPerhitunganKaryawanTetap.jsx"
import MenuPerhitunganKaryawanTidakTetap from "./components/Users/MenuPerhitungan/MenuPerhitunganKaryawanTidakTetap.jsx"
import MenuLaporanGaji from "./components/Users/MenuCetak/MenuLaporanGaji.jsx"
import MenuLaporanPph from "./components/Users/MenuCetak/MenuLaporanPph.jsx"
import MenuLaporanSlip from "./components/Users/MenuCetak/MenuLaporanSlip.jsx"
import MenuLaporanSpt from "./components/Users/MenuCetak/MenuLaporanSpt.jsx"
import Footer from "./components/Layout/Footer.jsx"
import AdminDashboard from "./components/Admin/AdminDashboard.jsx"
import AdminUserManagement from "./components/Admin/AdminUserManagement.jsx"

function App() {
  return (
    <Router>
      <Routes>
        <Route path="*"element={<><Navbar /><Error/></>}/>
        {/* USER */}
        <Route path="/"element={<><Navbar /><Login /><Footer/></>}/>
        <Route path="/menu-register" element={<><Navbar /><Register /><Footer/></>}/>
        <Route path="/menu-lupa-password" element={<><Navbar /><LupaPassword /><Footer/></>}/>
        <Route path="/menu-loading" element={<MenuLoading />}/>
        <Route path="/menu-dashboard/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuDashboard />}/>
        <Route path="/menu-perusahaan/:perusahaanParams" element={<MenuPerusahaan />}/>
        <Route path="/menu-karyawan-tetap/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuKaryawanTetap />}/>
        <Route path="/menu-ubah-karyawan-tetap/:idParams" element={<MenuUbahKaryawanTetap />}/>
        <Route path="/menu-karyawan-tidak-tetap/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuKaryawanTidakTetap />}/>
        <Route path="/menu-ubah-karyawan-tidak-tetap/:idParams" element={<MenuUbahKaryawanTidakTetap />}/>
        <Route path="/menu-perhitungan-karyawan-tetap/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuPerhitunganKaryawanTetap />}/>
        <Route path="/menu-perhitungan-karyawan-tidak-tetap/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuPerhitunganKaryawanTidakTetap />}/>
        <Route path="/menu-laporan-gaji/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuLaporanGaji />}/>
        <Route path="/menu-laporan-pph/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuLaporanPph />}/>
        <Route path="/menu-laporan-slip/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuLaporanSlip />}/>
        <Route path="/menu-laporan-coretax/:perusahaanParams/:bulanParams/:tahunParams" element={<MenuLaporanSpt />}/>
        {/* Admin */}
        <Route path="/adm13n"element={<><Navbar /><LoginAdmin /><Footer/></>}/>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/manajemen-user" element={<AdminUserManagement />} />
      </Routes>
    </Router>
  )
}


export default App;
